import React, { FC, useState, useEffect } from "react";
import {
  Container,
  NavWrapper,
  HeadWrapper,
  RightHeadContainer
} from './styles'
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useLocation, useParams } from "react-router-dom";
import { BackArrow, Tabs, TopProgress, Typography } from "../../../../components";
import {
  Overview,
  Permissions,
} from './components'
import { useUi } from "../../../../context/ui.context";
import { clientService } from "../../../../api";
import { usePageTitle } from "../../../../context/navigationContext";

const RolePage: FC = () => {
  const [t] = useTranslation()
  const [role, setRole] = useState<any>()
  usePageTitle(role ? `${t("PAGE_TITLE_ROLE_DETAIL")}: ${role?.display_name || role?.name}` : t("PAGE_TITLE_ROLE_DETAIL"))
  const [activeTab, setActiveTab] = useState<string>('overview')
  const location = useLocation()
  const tabs = [
    {
      title: t("OVERVIEW"),
      slug: 'overview',
      id: '1'
    },
    {
      title: t("PERMISSIONS"),
      slug: 'permissions',
      id: '2'
    },
  ]

  useEffect(() => {
    const currentTab = tabs.find((item: any) =>
      location.pathname?.split('/').includes(item.slug)
    );
    setActiveTab(currentTab?.slug || 'overview');
  }, [location.pathname])

  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const { roleId } = useParams();
  const { viewAlert } = useUi()

  useEffect(() => {
    if (roleId) {
      clientService.getUserRole(roleId)
        .then((res: any) => {
          setRole(res.data)
          setPageLoading(false)
        })
        .catch((e: any) => {
          if (e?.response?.data?.detail) {
            viewAlert({
              severity: 'error',
              message: e?.response?.data?.detail
            })
          }
          setPageLoading(false)
        })
    }
  }, [roleId, viewAlert])

  return (
    <>
      {pageLoading && <TopProgress />}
      <Container>
        <HeadWrapper>
          <BackArrow
            fallbackPath="/clients-users/roles"
          />
          <Typography variant="h2">
            {role?.display_name || role?.name || t("ROLE")}
          </Typography>
          <RightHeadContainer />
        </HeadWrapper>
        <NavWrapper>
          <Tabs
            tabs={tabs}
            size='display'
            location={activeTab}
            onChange={setActiveTab}
          />
        </NavWrapper>
        <Routes>
          <Route index element={<Navigate replace to="overview" />} />
          <Route path="overview" element={<Overview role={role} />} />
          <Route path="permissions" element={<Permissions role={role} roleId={roleId || ''} />} />
        </Routes>
      </Container>
    </>
  )
}

export default RolePage
